import { pickBy } from 'lodash';

import type { EffectParams } from '@swf/core/store';
import type { CasinoInterruptedGame, CasinoTable } from '@swf/core/types/CasinoGame';

const fetchFirstFsb = async (
  payload: { table: CasinoTable | CasinoInterruptedGame; fsbLaunch?: boolean; gameName: string },
  { dispatch, request }: EffectParams
) => {
  try {
    const { table, fsbLaunch, gameName } = payload;
    const { body } = await request({
      service: 'casino.player.firstfsb',
      body: pickBy({ tableId: table.id, currency: table.currency })
    });

    if (body) {
      if (fsbLaunch || !body.totalSpins || !body.remainingSpins) {
        const { userRollId, currency = table.currency, ttId = table.id } = body;
        dispatch.casino.play({
          table: { ...table, fsbId: userRollId, currency, id: ttId },
          fsb: body
        });
      } else {
        dispatch.modal.enqueue({
          path: '/notifications/first-fsb/',
          locationState: { table, fsb: body, gameName }
        });
      }
    }
  } catch (error) {
    dispatch.modal.enqueue({
      path: '/casino/error',
      locationState: { error }
    });
  }
};

export default fetchFirstFsb;
